module.exports = __webpack_public_path__ + "img/134.258f2669.jpg";